"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var _react = require("react");

var React = _interopRequireWildcard(_react);

var _reactBootstrap = require("react-bootstrap");

var _reactIntl = require("react-intl");

var _selectn = require("selectn");

var _selectn2 = _interopRequireDefault(_selectn);

var _tcombForm = require("tcomb-form");

var _tcombForm2 = _interopRequireDefault(_tcombForm);

var _StatusWrapper = require("../../../components/StatusWrapper");

var _StatusWrapper2 = _interopRequireDefault(_StatusWrapper);

var _reactRedux = require("react-redux");

var _actions = require("../../reducers/reportDetail/actions");

var _mapToState = require("../../mapToState");

var _lodash = require("lodash");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var Form = _tcombForm2.default.form.Form;

var ReportDetailDeleteTypeContentModal = function (_React$Component) {
    _inherits(ReportDetailDeleteTypeContentModal, _React$Component);

    function ReportDetailDeleteTypeContentModal(props) {
        _classCallCheck(this, ReportDetailDeleteTypeContentModal);

        var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ReportDetailDeleteTypeContentModal).call(this, props));

        _this.onHide = function () {
            _this.props.onClose();
        };
        _this.deleteReportContent = function () {
            var promise = void 0;
            if (_this.props.saveReportBeforeDeleteType) {
                promise = _this.props.dispatch((0, _actions.saveSelectedReport)()).then(function (val) {
                    var updated = _this.getUpdatedReportData();
                    return _this.props.dispatch((0, _actions.updateReport)(updated.selectedReport));
                });
            } else {
                var updated = _this.getUpdatedReportData();
                promise = _this.props.dispatch((0, _actions.updateReport)(updated.selectedReport));
            }
            (0, _mapToState.mapToState)(function () {
                return _this;
            }, function () {
                return promise.then(function (value) {
                    _this.props.onSuccess();
                });
            });
        };
        _this.state = {
            isLoading: false
        };
        return _this;
    }

    _createClass(ReportDetailDeleteTypeContentModal, [{
        key: "getUpdatedReportData",
        value: function getUpdatedReportData() {
            var selectedReport = this.props.reportDetail.selectedReport;
            var dataKey = this.props.currentReportData.dataKey;
            var selectedReportContent = this.props.selectedReportContent;

            console.log(selectedReport.data[dataKey]);
            selectedReport.data[dataKey] = (0, _lodash.chain)(selectedReport.data[dataKey]).filter(function (data) {
                return data.uid !== selectedReportContent.uid;
            }).value();
            // on type remove, we need to sychronize the typeReferences...
            (0, _lodash.remove)(selectedReport.data.typeReferences, function (ref) {
                // any ref1 or ref2 that matches must be removed!
                if (ref.ref1 === selectedReportContent.uid || ref.ref2 === selectedReportContent.uid) {
                    console.info("typeReferences deletion: remove typeReference (issue)", ref);
                    return true;
                }
                return false;
            });
            // furthermore we need to remove any reference typed fields in the data that matches the uid to remove...
            (0, _lodash.each)(selectedReport.data.fields, function (field) {
                if (field.type === "reference" && field.data.uid === selectedReportContent.uid) {
                    // must be nullified!
                    field.data = { uid: null }; // attention assignment!
                    console.info("instance deletion: nullify reference (first hierachy)", field);
                } else if (field.type === "table") {
                    var tableData = field.data;
                    (0, _lodash.remove)(tableData.rows, function (row) {
                        if (row.ref === selectedReportContent.uid) {
                            console.info("instance deletion: fully remove row", row);
                            return true;
                        } // remove the ref instance.
                        return false;
                    });
                    // furthermore we also need to nullify all references...
                    (0, _lodash.each)(tableData.rows, function (row) {
                        (0, _lodash.each)(row.fields, function (field) {
                            if (field.type === "reference" && field.data.uid === selectedReportContent.uid) {
                                // nullify
                                console.info("instance deletion: nullify deeply nested table row reference", field);
                                field.data = { uid: null }; // attention assignment!
                            }
                        });
                    });
                }
            });
            return {
                selectedReport: selectedReport
            };
        }
    }, {
        key: "render",
        value: function render() {
            var formatMessage = this.props.intl.formatMessage;

            var reportContent = (0, _selectn2.default)("selectedReportContent", this.props);
            var modal = null;
            if (reportContent) {
                var title = reportContent.title + " " + formatMessage({ id: "reportList.type.delete.modal.title.postfix" });
                modal = React.createElement(_reactBootstrap.Modal, { show: this.props.showModal, onHide: this.onHide, enforceFocus: false }, React.createElement(_StatusWrapper2.default, { isLoading: this.state.isLoading, error: this.state.error, onDismissError: this.state.dismissError }, React.createElement(_reactBootstrap.Modal.Header, { closeButton: true }, React.createElement(_reactBootstrap.Modal.Title, null, title)), React.createElement(_reactBootstrap.Modal.Body, null, React.createElement("p", null, React.createElement(_reactIntl.FormattedMessage, { id: "reportList.type.delete.modal.body" }))), React.createElement(_reactBootstrap.Modal.Footer, null, React.createElement(_reactBootstrap.Row, null, React.createElement(_reactBootstrap.Col, { xs: 12 }, React.createElement(_reactBootstrap.ButtonGroup, null, React.createElement(_reactBootstrap.Button, { bsStyle: "primary", onClick: this.deleteReportContent }, React.createElement("i", { className: "fa fa-times" }), " ", React.createElement(_reactIntl.FormattedMessage, { id: "reportList.delete.title" }))))))));
            }
            return modal;
        }
    }]);

    return ReportDetailDeleteTypeContentModal;
}(React.Component);
ReportDetailDeleteTypeContentModal = __decorate([_reactIntl.injectIntl, (0, _reactRedux.connect)(function (state) {
    return {
        reportDetail: state.reportDetail
    };
})], ReportDetailDeleteTypeContentModal);
exports.default = ReportDetailDeleteTypeContentModal;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/containers/reportDetail/ReportDetailDeleteTypeContentModal.tsx
 ** module id = 1274
 ** module chunks = 0
 **/